export interface PublicEntryStorageItemDTO {
  ID: string;
  FileName: string;
  ContentType: string;
  Size: number | null;
}
